export const firebaseConfig = {
  apiKey: "AIzaSyBCD0p7yWDw3XZxtDx9AsCjYQtRABrW67Q",
  authDomain: "portfolio-de5cd.firebaseapp.com",
  projectId: "portfolio-de5cd",
  storageBucket: "portfolio-de5cd.appspot.com",
  messagingSenderId: "340323829860",
  appId: "1:340323829860:web:e8d661619a291b99d5f771",
  measurementId: "G-J3MJV9C1VR"
};
